export const PlanStatus = Object.freeze({
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
  TRIALING: "trialing",
  UNPAID: "unpaid",
});

export const PlanFeatures = Object.freeze({
  "3e40c60f52c840cca83be5e44be707c8": [
    "Accede a los libros compartidos de la biblioteca",
    "Crea tus propias historias personalizadas",
    "Adquiere la versión impresa de tus historias *",
    "Recargas de créditos opcionales",
    "Comparte tus historias con otros suscriptores",
    "Crea personajes personalizados para tus historias",
    "Selecciona el idioma y estilo de tus historias",
    "Usa el editor de historias generadas",
  ],
  "028ab0b57c894dd282b8608f09fe182b": [
    "Crea personajes inspirados en personas reales",
    "Animaciones y efectos especiales en tus historias",
    "Escucha las historias con voces personalizadas",
    "Transforma tus historias en videos animados",
  ],
});
